<template>
  <footer>
    <div class="px-4 py-6 border-t border-gray-300 lg:px-10 xl:px-20 xl:py-6">
      <div class="container">
        <div class="flex flex-col items-center justify-between w-full md:flex-row">
          <div class="pb-8 md:pb-0">
            <svg viewBox="0 0 114 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-24'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_644_56)"><path d="M82.048 21.291h-4.316V4.652h4.316v16.64zM71.826 4.652L69.04 15.803l-3.255-11.15h-4.175l-3.253 11.15-2.787-11.15h-4.232L55.93 21.29h4.47l3.292-11.41 3.296 11.41h4.459l4.606-16.639h-4.227zm-20.841 11.93c0-3.18-1.693-4.259-5.393-5.465-1.744-.568-3.373-1.006-3.373-2.362 0-1.189 1.21-1.59 2.115-1.59.765 0 2.205.16 2.321 1.926h4.089c-.07-3.369-2.81-4.836-6.338-4.836-2.185 0-3.99.62-5.129 1.74a4.427 4.427 0 00-1.276 3.12c0 3.1 2.07 4.34 4.407 5.05 2.628.802 4.365 1.282 4.365 2.726 0 .966-.767 1.929-2.271 1.929-1.922 0-2.62-1.136-2.665-2.272h-4.134c0 3.835 3.232 5.238 6.799 5.238 4.543 0 6.492-2.594 6.492-5.21m46.34 0c0-3.67-2.67-4.64-5.907-5.604-1.556-.455-2.953-.868-2.953-2.224 0-1.188 1.209-1.59 2.115-1.59.77 0 2.203.16 2.32 1.926h4.088c-.07-3.369-2.808-4.836-6.34-4.836-2.183 0-3.995.62-5.127 1.74a4.437 4.437 0 00-1.276 3.12c0 3.1 2.064 4.34 4.409 5.05 2.626.802 4.368 1.282 4.368 2.726 0 .966-.766 1.929-2.272 1.929-1.926 0-2.626-1.136-2.666-2.272h-4.135c0 3.835 3.23 5.238 6.801 5.238 4.543 0 6.572-2.594 6.572-5.21m14.865 0c0-3.669-2.683-4.639-5.906-5.604-1.561-.455-2.953-.868-2.953-2.224 0-1.188 1.202-1.59 2.108-1.59.763 0 2.206.161 2.321 1.926h4.089c-.07-3.369-2.823-4.836-6.344-4.836-2.156.025-3.973.645-5.109 1.765a4.446 4.446 0 00-1.274 3.121c0 3.098 2.065 4.339 4.407 5.05 2.628.802 4.365 1.28 4.365 2.726 0 .965-.763 1.928-2.271 1.928-1.926 0-2.624-1.136-2.669-2.271h-4.148c0 3.834 3.226 5.247 6.815 5.247 4.559 0 6.587-2.594 6.587-5.211M28.453 26H0L20.855 0h14.004l-6.406 26z" fill="#C00"/><path d="M24.099 10.601V5.004H19.3v5.597h-5.597V15.4h5.593v5.6h4.8v-5.6h5.601V10.6h-5.6z" fill="#fff"/></g><defs><clipPath id="clip0_644_56"><path fill="#fff" d="M0 0h112.196v26H0z"/></clipPath></defs></svg>
          </div>

          <div class="pb-4 md:pb-0">
            <ul class="flex flex-wrap gap-6 text-sm md:flex-nowrap md:flex-row md:text-base">
              <li class="truncate">
                <a :href="imprintLink" target="_blank" class="inline-flex items-center hover:underline text-sw_yellow_error-text hover:text-sw_gray-700">
                  {{ tr('components.footer.links.imprint') }}
                </a>
              </li>
              <li class="truncate">
                <a :href="termsLink" target="_blank" class="inline-flex items-center hover:underline text-sw_yellow_error-text hover:text-sw_gray-700">
                  {{ tr('components.footer.links.termsAndConditions') }}
                </a>
              </li>
              <li class="truncate">
                <a :href="privacyLink" target="_blank" class="inline-flex items-center hover:underline text-sw_yellow_error-text hover:text-sw_gray-700">
                  {{ tr('components.footer.links.privacy') }}
                </a>
              </li>
              <li class="truncate">
                <router-link :to="$i18nTo({ name: 'faq' })" class="inline-flex items-center hover:underline text-sw_yellow_error-text hover:text-sw_gray-700">
                  {{ tr('components.footer.links.faq') }}
                </router-link>
              </li>
            </ul>
          </div>
          <div>
            <div>
              <img
                class="alliance_logo white"
                src="../../../images/swiss/logos/a_star_alliance2.png"
                alt="A Star Alliance member"
                style="width: 205px;"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import Footer from '~brand-components/base/shared/footer'

export default Footer.extend({

  computed: {
    termsLink(): string {
      if (this.$i18n.locale === 'de') {
        return 'https://www.swiss.com/ch/de/book-and-manage/conditions/voucher-conditions'
      }

      if (this.$i18n.locale === 'fr') {
        return 'https://www.swiss.com/ch/fr/book-and-manage/conditions/voucher-conditions'
      }

      if (this.$i18n.locale === 'it') {
        return 'https://www.swiss.com/ch/it/book-and-manage/conditions/voucher-conditions'
      }

      return 'https://www.swiss.com/ch/en/book-and-manage/conditions/voucher-conditions'
    },
    imprintLink(): string {
      if (this.$i18n.locale === 'de') {
        return 'https://www.swiss.com/ch/de/terms-conditions/imprint'
      }

      if (this.$i18n.locale === 'fr') {
        return 'https://www.swiss.com/ch/fr/terms-conditions/imprint'
      }

      if (this.$i18n.locale === 'it') {
        return 'https://www.swiss.com/ch/it/terms-conditions/imprint'
      }

      return 'https://www.swiss.com/ch/en/terms-conditions/imprint'
    },
    privacyLink(): string {
      if (this.$i18n.locale === 'de') {
        return 'https://www.swiss.com/ch/de/terms-conditions/privacy-statement'
      }

      if (this.$i18n.locale === 'fr') {
        return 'https://www.swiss.com/ch/fr/terms-conditions/privacy-statement'
      }

      if (this.$i18n.locale === 'it') {
        return 'https://www.swiss.com/ch/it/terms-conditions/privacy-statement'
      }

      return 'https://www.swiss.com/ch/en/terms-conditions/privacy-statement'
    },
  },
})
</script>
